import React, { Component } from 'react';
import style from './index.module.css';

class Chapter11 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, chargeTimesRatio, times, remark } = this.props.data;
    // if (status === 0) return;
    let type = '';
    let typeDesc = '';
    let typeTips = '';
    let typeMark = '';
    let typeStandard = '';
    if (status === 1) {
      type = '高峰期';
      typeDesc = '与其高峰期加电，不如低谷时积蓄能量';
      typeTips = '温馨提示：错峰充电，节能高效';
      typeMark = `注：${remark}`;
      typeStandard = '各地峰谷时段划分标准不一，请以本地政策为准。';
    } else if (status === 2) {
      type = '平峰期';
      typeDesc = '不挤高峰期，充电更舒适';
      typeTips = '温馨提示：错峰充电，节能高效';
      typeMark = `注：${remark}，`;
      typeStandard = '各地峰谷时段划分标准不一，请以本地政策为准。';
    } else if (status === 3) {
      type = '夜间低谷';
      typeDesc = '无论多晚，都有我们的陪伴';
      typeTips = '';
      typeMark = `注：${remark}，`;
      typeStandard = '各地峰谷时段划分标准不一，请以本地政策为准';
    } else {
      type = '---';
      typeDesc = '---';
      typeTips = '---';
      typeMark = '---';
      typeStandard = '---';
    }

    return (
      <div className={style.pageBox}>
        <div
          className={style.itemBox}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: document.documentElement.clientHeight - 310
          }}
        >
          {/* <div className={style.xpIconBox} /> */}
          <p className={style.ordinaryText}>
            2021年
            <br />
            你最常在{type}充电，共
            <span className={style.blueNormalText}>{times || '---'}次</span>
            <br />
            <span className={style.blueBigText}>
              占总充电次数的
              <br />{chargeTimesRatio || '---'}
            </span>
            <br />
            <span className={style.grayNormalText}>{typeDesc}</span>
          </p>
          <div
            className={
              status === 1
                ? style.chapter1101Icon
                : status === 2
                  ? style.chapter1102Icon
                  : style.chapter1103Icon
            }
          />
          <div style={{ marginTop: 152 }}>
            <p className={style.ordinaryText}>
              <span className={style.typeTipsText}>{typeTips}</span>
              <br />
              <span className={style.graySmallText}>
                {typeMark}
                <br />
                {typeStandard}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Chapter11;
